import { PartyEntityCodes } from '../types/PartyEntityCodes';

export const PARTY_DETAILS_ENDPOINT_MAP = {
  [PartyEntityCodes.Insured]: 'claim-sets-where-insured',
  [PartyEntityCodes.Claimant]: 'claims-where-claimant',
  [PartyEntityCodes.Beneficiary]: 'claims-where-beneficiary',
  [PartyEntityCodes.HasContacts]: 'party-contacts',
  [PartyEntityCodes.IsContact]: 'contacts-where-contact',
} as const;
